import { css } from '@emotion/core';

export const boxStyle = css`
  background-color: #fff6ff;
  border-radius: 25px;
  margin: 25px;
  padding: 25px;
  text-align: center;
`;
